import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import FormInputSearch from './FormInputSearchItem';
import DbSearch from '../../db/DbSearch';

export default function FormInputDbSearch(props) {
  const {
    allowSelectAll = false,
    filter,
    serverFilter = {},
    showAll = false,
    sortBy = '',
    modelName,
    keyValue,
  } = props.search;

  const searchProps = {
    allowSelectAll,
    modelName,
    showAll,
    sortBy,
    serverFilter,
  };

  if (keyValue) {
    searchProps.validationKeyValue = keyValue;
  }

  if (filter) {
    let filterFunction;
    if (Array.isArray(filter)) {
      filterFunction = suggestions => {
        return _.filter(suggestions, s => filter.includes(s.id));
      };
    } else if (_.isFunction(filter)) {
      filterFunction = filter;
    }

    searchProps.filterSuggestions = filterFunction;
    delete props.search.filter; // hack to avoid invalid filter to propagate to child component
  }

  return <FormInputSearch {...props} searchComponent={DbSearch} searchProps={searchProps} />;
}

FormInputDbSearch.defaultProps = {
  search: {},
};

FormInputDbSearch.propTypes = {
  search: PropTypes.object,
};
